import { PageHeader } from '@zeiss/lib-components';
import { useTranslation } from 'react-i18next';

import { Result } from './';

export const ApplicationLists = () => {
  const { t } = useTranslation(['common']);

  return (
    <>
      <PageHeader headline={t('common:glossary.applicationList_other')} />

      <Result />
    </>
  );
};
